import React, { Component } from "react";
import {  Form, Input, Space, Button,Descriptions,message, Divider,Typography,Modal} from 'antd';
import {dbFields}  from '../../model/device_finance/column';
import { getDeviceFinance, updateNextPayDl ,showReminder,stopShowReminder,clearConflictTestData} from "../../model/device_finance/requests";
import BreadcrumbCustomer from "../breadcrumb";
import storage from "../../utils/storage";
import { configs } from "../../config/config";
import { checkDfpState } from "../../utils/utils";

export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

const {  Paragraph } = Typography;
class DeviceFinance extends Component {
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state = {
            imei:"",
            curef:"",
            brand:"",
            model:"",
            nextPayDlToDate:"",
            desiredPayDl:"",
            visiable:true,
            reminderVisiable:true,
            addVisiable:true,
            reminderStopVisiable:true,
            stopAddVisiable:true,
            actualData :{},
        }
    }
    handlerSubmit = (e) => {
        let imei = this.formRef.current.getFieldValue(dbFields.imei.key)
        getDeviceFinance({id:imei}).then(res=>{
           if(res.data.code === 200){
               let data = res.data.data
                this.setState({
                    imei:data.imei,
                    brand:data.brand,
                    model:data.model,
                    curef:data.reference,
                    nextPayDlToDate:data.next_pay_dl_to_date,
                    addVisiable:false,
                    stopAddVisiable:false,
                    reminderVisiable:false,
                    reminderStopVisiable:false,
                    actualData:data.raw_data,
                    desiredPayDl:data.desired_next_pay,
                })
           }else{
               message.error(res.data.msg)
           }
        }).catch(err=>{
            message.error(err)
        })

    }

    handlerNextPay = (e) => {
        let data = this.state.actualData
        if(!data.hasOwnProperty('actual_dev_stat') || data.actual_dev_stat.next_pay_dl <= 0 || data.actual_dev_stat.next_reminder <= 0 ){
            message.error("Device is not correctly activated")
            return false;
        }
        let imei = this.formRef.current.getFieldValue(dbFields.imei.key)
        updateNextPayDl({imei:imei}).then(res=>{
            if (res.data.code === 200) {
                message.success("set next_pay_dl ok")
                this.setState({
                    reminderVisiable:true,
                    reminderStopVisiable:true
                })
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    showReminder = (e) =>{
        let data = this.state.actualData
        if(!checkDfpState(data)){
            message.error("Device is not correctly activated")
            return false;
        }
        let imei = this.formRef.current.getFieldValue(dbFields.imei.key)
        showReminder({imei:imei}).then(res=>{
            if(res.data.code === 200){
                message.success("set reminder ok")
                this.setState({
                    stopAddVisiable:true,
                    addVisiable:true
                })
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })

    }

    stopShowReminder = (e) => {
        let data = this.state.actualData
        if(!checkDfpState(data)){
            message.error("Device is not correctly activated")
            return false;
        }
        let imei = this.formRef.current.getFieldValue(dbFields.imei.key)
        // should stop all the reminder case or just stop the case with the imei
        stopShowReminder({imei:imei}).then(res=>{
            if(res.data.code === 200){
                message.success("stop reminder ok")
                this.setState({
                    stopAddVisiable:true,
                    reminderVisiable:true,
                    reminderStopVisiable:true,
                    addVisiable:true
                })
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })

    }

    clearConflictTestData = (e) => {
        let imei = this.formRef.current.getFieldValue(dbFields.imei.key)
        clearConflictTestData({imei:imei}).then(res=>{
            if(res.data.code === 200){
                message.success("clear conflict data ok")
                this.setState({
                    stopAddVisiable:true,
                    reminderVisiable:true,
                    reminderStopVisiable:true,
                    addVisiable:true
                })
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })

    }

    onModal = (e)=>{
        this.setState({
            isModalOpen:true
        },()=>{
            console.log(this.state.isModalOpen)
        })
    }
    componentWillUnmount(){

        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    render(){
        const {open} = this.state
        return(
            <>
            <BreadcrumbCustomer  first='Device Info Check' second='' />

                <Divider />
             <Form
                    ref={this.formRef}
                >
                    <Form.Item
                          name="imei"
                          label="Imei"
                    >
                         <Input />
                    </Form.Item>

                    <Form.Item
                    >
                    <Space wrap>
                     <Button 
                         type="primary"
                         onClick={this.handlerSubmit}
                         style={{background: "#851dd6",color:"white" }}
                        >
                            search
                        </Button>
                
                     <Button 
                         type="primary"
                         disabled = {this.state.addVisiable}
                         onClick={this.handlerNextPay}
                         style={{background: "#851dd6",color:"white" }}
                        >
                            Add 7 Days
                        </Button>
                        <Button 
                            type="primary"
                            disabled = {this.state.stopAddVisiable}
                            onClick={this.clearConflictTestData}
                            style={{background: "#851dd6",color:"white" }}
                        >
                            Clear
                        </Button>
                        <Button 
                         type="primary"
                         disabled = {this.state.reminderVisiable}
                         onClick={this.showReminder}
                         style={{background: "#851dd6",color:"white" }}
                        >
                            Show  Reminder
                        </Button>
                        <Button 
                         type="primary"
                         disabled = {this.state.reminderStopVisiable}
                         onClick={this.stopShowReminder}
                         style={{background: "#851dd6",color:"white" }}
                        >
                            Stop Reminder
                        </Button>
                        </Space>
                    </Form.Item>    
                </Form>
                <Divider />        
                 <Descriptions bordered title="Actual Dev Stat">
                    <Descriptions.Item label={dbFields.imei.title}>{this.state.imei}</Descriptions.Item>
                    <Descriptions.Item label={dbFields.curef.title}>{this.state.curef}</Descriptions.Item>
                    <Descriptions.Item label={dbFields.brand.title}>{this.state.brand}</Descriptions.Item>
                    <Descriptions.Item label={dbFields.model.title}>{this.state.model}</Descriptions.Item>
                    <Descriptions.Item label={dbFields.next_pay_dl.title}>
                        {this.state.nextPayDlToDate}
                    </Descriptions.Item>
                    <Descriptions.Item label="Desired_Pay_dl">
                        {this.state.desiredPayDl}
                    </Descriptions.Item>
                </Descriptions>
                <Divider />    
                <pre>
                    {JSON.stringify(this.state.actualData,null,2)}
                    </pre>
                 {/* <Typography >
                     <Paragraph>
                     <ul>
                            <li >
                            Here you can check the project information of a specific device.
                            </li>
                            <li>
                            CuRef (ComRef) is the ID of a batch of devices. One “Model” may have several CuRef.
                            </li>
                            <li>
                            NextPayDate is time of UTC timezone.
                            </li>
                            <li>
                            If an IMEI of a user device cannot be found in this system, then either this phone has not been activated by assigning an effective due date , or the IMEI is not valid for your Device Financing program, for example
                                <ul>
                                    <li>
                                    It is a fake IMEI which were maliciously modified by user, i.e. it is not the original IMEI of this device.
                                    </li>
                                    <li>
                                    This device is financed by some other company, and your account can not access the devices of any other companies.
                                    </li>
                                </ul>
                            </li>
                        </ul>
                     </Paragraph>
                </Typography>  */}
            </>
        )
    }
}
export default DeviceFinance;